module.exports = __webpack_public_path__ + "static/media/cn.9caece66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cn.svg
// module id = 89
// module chunks = 0